import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AlignRightIcon } from '../icons';
import { ToolbarButton } from '../ui';
import { getAlignToContainer, getSelectedObjectsIDs } from '../editor';
import { getCurrentPiece, alignObjectsToRight } from '../project';

const ButtonAlignRight = ({ disabled, onClick }) => {
  if (disabled) {
    return null;
  }

  return <ToolbarButton icon={<AlignRightIcon />} onClick={onClick} />;
};

ButtonAlignRight.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const reduxConnector = connect(
  state => {
    let container = getCurrentPiece(state);
    if (!getAlignToContainer(state)) {
      container = null;
    }

    const ids = getSelectedObjectsIDs(state);
    let disabled = true;
    if (ids.size >= 1) {
      disabled = false;
    }
    return { ids, disabled, container };
  },
  { alignObjectsToRight },
  ({ ids, container, ...state }, actions) => ({
    ...state,
    onClick: () => actions.alignObjectsToRight({ ids, container }),
  }),
);

export default reduxConnector(ButtonAlignRight);
